import { render, staticRenderFns } from "./CreateJob.vue?vue&type=template&id=335a2e8c&scoped=true"
import script from "./CreateJob.vue?vue&type=script&lang=js"
export * from "./CreateJob.vue?vue&type=script&lang=js"
import style0 from "./CreateJob.vue?vue&type=style&index=0&id=335a2e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a2e8c",
  null
  
)

export default component.exports